import styled from 'styled-components';
import { Theme } from '@mui/material/styles';
import { createStyles, makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    userName: {
      fontSize: 14,
      color: theme.palette.getContrastText(theme.headerColor),
      margin: 0,
      fontWeight: 'bold',
      textAlign: 'left',
      '@media (max-width: 425px)': {
        fontSize: 12
      }
    },
    countriesIcon: {
      marginLeft: 15,
      width: 54,
      cursor: 'pointer',
      '@media (max-width: 425px)': {
        width: 49
      }
    },
    iconUserBox: { marginRight: 8, color: theme.palette.common.black },
    textUserBox: { color: theme.palette.common.black },
    versionText: {
      fontSize: 12,
      color: theme.palette.getContrastText(theme.headerColor)
    },
    containerUser: {
      textAlign: 'unset',
      backgroundColor: 'transparent',
      border: 'none',
      padding: 0,
      '@media (max-width: 425px)': {
        marginLeft: 0,
        padding: '0px 8px 0px 0px !important'
      }
    },
    popupUserName: {
      paddingTop: 5,
      color: theme.palette.common.black
    }
  })
);

export const ButtonCart = styled.button`
background-color: transparent;
border: none;
color: ${({ theme }) => theme.pantone656C};
`;

export const AreaByXnuup = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 6px;

	span {
		font-weight: bold;
		font-size: 0.875rem;
		margin-top: -2px;
	}

	img {
		max-width: 65px;
		max-height: 18px;
	}
`;